var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Box, Button, Grid, makeStyles, TextField, Typography, } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import { useKpayOtpValidation } from "./useKpayOtpValidation/useKpayOtpValidation";
import InputMask from "react-input-mask";
var useStyles = makeStyles(function () { return ({
    promotionalText: {
        fontSize: "15px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "18px",
    },
    textInvalid: {
        fontSize: "14px",
    },
}); });
export var KpayOtpValidation = function () {
    var classes = useStyles();
    var state = useKpayOtpValidation();
    return (React.createElement(Grid, { container: true, direction: "column", justify: "center", spacing: 3 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { color: "primary", align: "center", variant: "h5" },
                React.createElement(T, { id: "otpTextVerification.verification" }))),
        React.createElement(Grid, { item: true, xs: 12, md: 12 },
            React.createElement(Box, { pb: 1 },
                React.createElement(Typography, { variant: "subtitle1" },
                    React.createElement(T, { id: "kpayOtp.safetyHelper" }))),
            React.createElement(Box, null,
                React.createElement(Typography, { className: classes.promotionalText },
                    React.createElement(T, { id: "kpayOtp.emailCodeHelper" })))),
        React.createElement(Grid, { item: true, xs: 12, md: 12 },
            React.createElement(T, null, function (_a) {
                var translate = _a.translate;
                return (React.createElement(InputMask, { mask: "99999", maskChar: null, onChange: state.handleKpayOtpChange }, function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { fullWidth: true, name: "name", variant: "outlined", placeholder: translate("kpayOtp.codePlaceholderHelper") }))); }));
            }),
            state.isInvalidKpayOtp && (React.createElement(Box, { mt: 1, display: "flex", justifyContent: "center" },
                React.createElement(Typography, { color: "error", className: classes.textInvalid },
                    React.createElement(T, { id: "kpayOtp.wrongCodeError" }))))),
        React.createElement(Grid, { item: true, xs: 12, md: 12 },
            React.createElement(Button, { variant: "contained", size: "large", color: "primary", fullWidth: true, onClick: state.handleKpayOtpCheck },
                React.createElement(T, { id: "otpTextVerification.confirmCode" })))));
};
export default KpayOtpValidation;
